.root {
  border-radius: var(--paper-radius);
  cursor: pointer;

  &:active {
    & > div > img {
      outline: var(--mantine-spacing-xs) solid var(--mantine-color-primary-light);
    }
    transform: translateY(calc(0.0625rem * var(--mantine-scale)));
  }
}

.image {
  height: 100%;
  object-position: center center;
  transition: transform 300ms ease;
  transform-origin: center;
}

.root:hover .image {
  transform: scale(1.05);
}
